// React
import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
//API
import { WoundApi } from '../../apis/index';
//Material-UI
import Grid from '@material-ui/core/Grid';
//Components
import MyLoading from '../../components/Loading.js';

const WoundMetaUpdate = (props) => {
  const id = props.match.params.id;
  const [woundInfo, setWoundInfo] = useState({
    woundName: '',
    ink2Ratio: 0,
    woundType: 0,
    stlThreshold: 0,
  });
  const [loading, setLoading] = useState(false);

  const getWoundDetail = async (url) => {
    const res = await WoundApi.getWoundDetail(id);
    setWoundInfo(res.data);
  };
  useEffect(() => {
    getWoundDetail();
  }, []);

  const changeValue = (e) => {
    setWoundInfo({
      ...woundInfo,
      [e.target.name]: e.target.value,
    });
  };

  const setDate = (utcDate) => {
    const date = new Date(utcDate);
    date.setHours(date.getHours() + 9);
    return date.toISOString().replace('T', ' ').substring(0, 19);
  };

  const submitWound = async (e) => {
    e.preventDefault(); // 기존 submit 을 실행하지않게
    const formData = new FormData();
    formData.append('woundName', woundInfo.woundName);
    formData.append('ink2Ratio', woundInfo.ink2Ratio);
    formData.append('woundType', woundInfo.woundType);
    formData.append('stlThreshold', woundInfo.stlThreshold);
    setLoading(true);
    const res = await WoundApi.updateWound(id, formData);
    if (res !== null && res.statusCode === 200) {
      props.history.push('/woundMetaList');
    } else {
      setLoading(false);
      alert('Wound Info 수정 실패');
    }
  };

  const deleteWound = async () => {
    setLoading(true);
    const res = await WoundApi.deleteWound(id);
    if (res.statusCode === 200) {
      props.history.push('/woundMetaList');
    } else {
      setLoading(false);
      alert(res.statusCode + '\n' + res.message);
    }
  };

  return (
    <Form onSubmit={submitWound} onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}>
      <Form.Group>
        <Form.Label>Wound Name</Form.Label>
        <Form.Control
          type="text"
          placeholder="WoundName"
          onChange={changeValue}
          name="woundName"
          value={woundInfo.woundName}
          required
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>ink2Ratio</Form.Label>
        <Form.Control
          type="number"
          placeholder="ink2Ratio"
          onChange={changeValue}
          name="ink2Ratio"
          value={woundInfo.ink2Ratio}
          onWheel={(e) => e.target.blur()}
          min={0}
          max={50}
          required
        />
        <span style={{ fontSize: '.8rem', color: '#555' }}>
          - SKIN : 20 (Default)
          <br />- CARTILAGE : 40
        </span>
      </Form.Group>
      <Form.Group>
        <Form.Label>Wound Type</Form.Label>
        <Form.Control
          type="number"
          placeholder="woundType"
          onChange={changeValue}
          name="woundType"
          value={woundInfo.woundType}
          onWheel={(e) => e.target.blur()}
          min={0}
          max={100}
          required
        />
        <span style={{ fontSize: '.8rem', color: '#555' }}>
          - SKIN : 0 ~ 49
          <br />
          - CARTILAGE : 50 ~ 98
          <br />- OTHER : 99
        </span>
      </Form.Group>
      <Form.Group>
        <Form.Label>STL Threshold</Form.Label>
        <Form.Control
          type="number"
          placeholder="stlThreshold"
          onChange={changeValue}
          name="stlThreshold"
          value={woundInfo.stlThreshold}
          onWheel={(e) => e.target.blur()}
          required
        />
      </Form.Group>
      <div style={{ display: 'flex' }}>
        <Form.Group style={{ marginRight: '20px', width: '50%' }}>
          <Form.Label style={{ fontWeight: 'bold' }}>Insert Date</Form.Label>
          <div
            style={{
              border: '1px solid #3F598C',
              borderRadius: '5px',
              padding: '10px 0px 10px 10px',
              background: '#DADADA',
              minHeight: '40px',
            }}
          >
            {woundInfo.insertDate && (
              <div>{setDate(woundInfo.insertDate)} (KST)</div>
            )}
          </div>
        </Form.Group>
        <Form.Group style={{ marginLeft: '20px', width: '50%' }}>
          <Form.Label style={{ fontWeight: 'bold' }}>Insert ID</Form.Label>
          <div
            style={{
              border: '1px solid #3F598C',
              borderRadius: '5px',
              padding: '10px 0px 10px 10px',
              background: '#DADADA',
              minHeight: '40px',
            }}
          >
            {woundInfo.insertId}
          </div>
        </Form.Group>
      </div>
      <div style={{ display: 'flex' }}>
        <Form.Group style={{ marginRight: '20px', width: '50%' }}>
          <Form.Label style={{ fontWeight: 'bold' }}>Modify Date</Form.Label>
          <div
            style={{
              border: '1px solid #3F598C',
              borderRadius: '5px',
              padding: '10px 0px 10px 10px',
              background: '#DADADA',
              minHeight: '40px',
            }}
          >
            {woundInfo.insertDate && (
              <div>{setDate(woundInfo.modifyDate)} (KST)</div>
            )}
          </div>
        </Form.Group>
        <Form.Group style={{ marginLeft: '20px', width: '50%' }}>
          <Form.Label style={{ fontWeight: 'bold' }}>Modify ID</Form.Label>
          <div
            style={{
              border: '1px solid #3F598C',
              borderRadius: '5px',
              padding: '10px 0px 10px 10px',
              background: '#DADADA',
              minHeight: '40px',
            }}
          >
            {woundInfo.modifyId}
          </div>
        </Form.Group>
      </div>
      <Grid
        container
        direction="row"
        justifyContent="center"
        alignItems="center"
      >
        <button
          onClick={() => {
            props.history.goBack();
          }}
        >
          Back
        </button>
        <button className="blue" style={{ margin: '0px 50px' }} type="submit">
          Save
        </button>
        <button className="red" onClick={deleteWound}>
          Delete
        </button>
      </Grid>
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <MyLoading />
        </div>
      )}
    </Form>
  );
};

export default WoundMetaUpdate;
